import { render } from "./app-footer.vue?vue&type=template&id=a29f3486&scoped=true"
import script from "./app-footer.js?vue&type=script&lang=js&external"
export * from "./app-footer.js?vue&type=script&lang=js&external"

import "./app-footer.scss?vue&type=style&index=0&id=a29f3486&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a29f3486"]])

export default __exports__